import type { ModuleRoute } from '@modules/lfour/routes';
import {
  appRoutes,
  guestRoutes,
  loginElement,
  preloadRoute,
  publicRoutes,
  STATIC_PUBLIC_PATHS,
  verifyEmailElement
} from '@modules/lfour/routes';

export type { ModuleRoute };
export const moduleRoutes: ModuleRoute[] = [...appRoutes];
export const moduleGuestRoutes: ModuleRoute[] = [...guestRoutes];
export const modulePublicRoutes: ModuleRoute[] = [...publicRoutes];
export { loginElement, preloadRoute, STATIC_PUBLIC_PATHS, verifyEmailElement };
